"use client";

import Image from "next/image";
import Link from "next/link";

const AboutIndustries = ({ data }) => {
  // Defensive check for data
  if (!data?.slides?.[0]) return null;
  const banner = data.slides[0];

  return (
    <section 
      className="relative w-full h-[80vh] overflow-hidden rounded-3xl bg-slate-900"
      aria-labelledby="hero-heading"
    >
      {/* 1. Performance: LCP Optimization */}
      <Image
        src={banner.image}
        // Descriptive alt is better for SEO than "Hero Background"
        alt={banner.title || "Industry overview"} 
        fill
        priority // Critical for LCP
        quality={85}
        sizes="100vw"
        className="object-cover transition-opacity duration-500"
      />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60" aria-hidden="true"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white px-6">

        
        {/* 2. SEO: Semantic Heading */}
        {/* <h1 
          id="hero-heading"
          className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold mb-6 tracking-tight"
        >
========= */}

        <h1 className="text-2xl md:text-4xl lg:text-5xl font-serif font-bold mb-6">
{/* >>>>>>>>> Temporary merge branch 2 */}
          {banner.title}
        </h1>

        {/* 3. Accessibility: Improved contrast and readability */}
        <p className="text-lg md:text-xl max-w-2xl text-slate-100 leading-relaxed">
          {banner.subtitle}
        </p>

        <Link
          href={data.buttonLink || "#"}
          className="mt-10 px-8 py-4 bg-white text-black rounded-full font-semibold outline-offset-4 hover:bg-brand hover:text-white transition-all duration-300 focus-visible:ring-4 focus-visible:ring-white/50"
          aria-label={`${data.button} about our industries`}
        >
          {data.button}
        </Link>
      </div>
    </section>
  );
};

export default AboutIndustries;